import styled from '@emotion/styled';
import LogisticsList from './LogisticsList';

export const LogisticsContent = styled(LogisticsList)`
  width: 280px;
  max-height: 500px;
  margin: -12px -16px;
  overflow: auto;
  > div {
    margin-bottom: 15px;
  }
`;

export const Between = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const DetailItem = styled(Between)`
  height: 32px;
  font-size: 12px;
  color: #515359;
`;

export const LogisticsItem = styled(DetailItem)`
  > div {
    display: flex;
    align-items: center;
    > span {
      margin-left: 4px;
    }
  }
`;

export const LogisticsSend = styled.div`
  display: flex;
  justify-content: flex-end;
  > button {
    padding-right: 0;
    font-size: 12px;
  }
`;

export const DetailImg = styled.img`
  width: 16px;
  height: 16px;
`;
